import {
    Route,
    Routes,
} from 'react-router-dom';

import {IndexPage} from './pages/IndexPage';
import {DetailPage} from './pages/DetailPage';
import {rbacActions} from '../../config/rbac/actions';
import {AuthorizedRouteElement} from '../../components/AuthorizedRouteElement.tsx';

// FNP-1248 — index and detail.
//
// ⚠️ NO ADD OR EDIT ROUTE, and that is not an omission. Connecting happens in a
// drawer over the index (the drawer pattern), and re-validating in a drawer over
// the detail page. Neither is a page, because neither is a destination a tenant
// should be able to deep-link into or land on after a refresh holding a
// half-entered credential.
//
// ⚠️ Uses `AuthorizedRouteElement`, NOT `AllowedRouteElement`. The latter infers
// loading from `allowedActions.length === 0`, which reads a genuinely
// unprivileged user as perpetually loading and parks them on a spinner.

export const ProviderConnectionsLayout = () => {

    return (
        <Routes>
            <Route
                path='/'
                element={
                    <AuthorizedRouteElement
                        rbacAction={rbacActions.ListProviderConnections}
                        redirectTo='/dashboard'
                    >
                        <IndexPage/>
                    </AuthorizedRouteElement>
                }
            />
            <Route
                path=':connectionId'
                element={
                    <AuthorizedRouteElement
                        rbacAction={rbacActions.GetProviderConnection}
                        redirectTo='/provider-connections'
                    >
                        <DetailPage/>
                    </AuthorizedRouteElement>
                }
            />
        </Routes>
    );
};
